/**
 * Created by axmin on 10.10.2016 г..
 */
import { PIXILoader } from "./PIXILoader";

export class LayoutImporter {

    private _elementsWithID: any;
    private _mainContainer: PIXI.Container;
    private _pixiLoader: PIXILoader;

    constructor() {

    }

    import(json, loader: PIXILoader) {
        this._elementsWithID = {};
        this._pixiLoader = loader;
        this._mainContainer = this.importElements(json);
        return {
            "elementsWithID": this._elementsWithID,
            "mainContainer": this._mainContainer
        }
    }

    private importElements(json) {
        const parent = this.switchType(json);
        if (json.children) {
            for (var i = 0; i < json.children.length; i++) {
                const child = this.importElements(json.children[i]);
                this.checkForIDandAdd(child, json.children[i], parent);
            }
        }

        return parent;
    }

    private switchType(json) {
        var element;

        switch (json.type) {
            case "rectangle":
                element = this.createRectangle(json);
                break;
            case "roundedRect":
                element = this.createRoundedRectangle(json);
                break;
            case "image":
                element = this.createImage(json);
                break;
            case "text":
                element = this.createText(json);
                break;
            case "BText":
                element = this.createBitmapText(json);
                break;
            default:
                element = new PIXI.Container();
        }

        return element;
    }

    private createRectangle(props: any): any {
        var rect: any = new PIXI.Graphics();

        rect.lineStyle(props.strokeWidth, props.strokeColor);
        rect.beginFill(props.fillColor, props.graphicsAlpha);
        rect.drawRect(0, 0, props.width, props.height);
        rect.endFill();
        rect.position = { x: props.x, y: props.y };

        return rect;
    }

    private createRoundedRectangle(props: any): any {
        var rect: any = new PIXI.Graphics();

        rect.lineStyle(props.strokeWidth, props.strokeColor);
        rect.beginFill(props.fillColor);
        rect.drawRoundedRect(0, 0, props.width, props.height, props.radius);
        rect.endFill();
        rect.position = { x: props.x, y: props.y };

        return rect;
    }

    private createImage(props: any): any {
        var img: any = new PIXI.Sprite();
        img.texture = this._pixiLoader.getTexture(props.picID);
        img.position.x = props.x;
        img.position.y = props.y;
        img.scale = new PIXI.Point(props.scale,props.scale);
        //img.texture.frame = new PIXI.Rectangle(props.frameX, props.frameY, props.frameWidth, props.frameHeight);

        return img;
    }

    private createText(props: any): any {
        const style = {
            fontSize: props.fontSize,
            stroke: props.strokeColor,
            fill: props.fillColor,
            strokeThickness: props.strokeWidth,
            align: props.align,
            lineHeight: props.lineHeight,
            fontFamily: props.fontFamily,
            dropShadow: props.dropShadow,
            dropShadowBlur: props.shadow,
            dropShadowDistance: props.dropShadowDistance,
            dropShadowColor: props.shadowColor,
            fontWeight: props.fontWeight,
            wordWrap: props.wordWrap,
            wordWrapWidth: props.wordWrapWidth
        };

        const text: any = new PIXI.Text(props.text, style as any);
        text.position.x = props.x;
        text.position.y = props.y;

        return text;
    }

    private createBitmapText(props: any): any {
        const style = {
            font: {
                name: props.fontFamily,
                size: props.fontSize
            },
            align: props.align,

        };

        const text: any = new PIXI.extras.BitmapText(props.text, style as any);
        text.position.x = props.x;
        text.position.y = props.y;

        return text;
    }

    private checkForIDandAdd(element, props, parent) {
        if (props.id != "" && props.id != null) {
            this._elementsWithID[props.id] = element;
            parent[props.id] = element;
        }

        parent.addChild(element);
    }
}
